module.exports = __webpack_public_path__ + "static/media/logo.1df326f9.png";